
import GridContainer from "./ui/GridContainer";
import { Link } from 'react-router-dom';


export function Home() {
    const featuresBasic = ["1 Static Websites", "SSL Certificate", "Custom Domain", "Unmetered Traffic"];
    const featuresMedium = ["2 Static Websites", "SSL Certificate", "Custom Domain", "Unmetered Traffic"];
    const featuresPro = ["4 Static Websites", "SSL Certificate", "Custom Domain", "Unmetered Traffic"];

    return (
        <>
            {/* Hero Section */}
            <section className="bg-gray-100 py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <br/>
                        <h1 className="text-5xl md:text-5xl font-bold mb-6">Monroe Township Fire District #1</h1>
                    </div>
                    
                    <center>

<hr/>
	<p><strong><font size="+1">Meetings are held on the second Wednesday of every month at 6:30 PM.</font></strong></p>
	<br/>
     {/*
	<p><strong><font size="+2">We are hiring a Firefighter/Fire Inspector.<br/> Applications must be completed and submitted prior to November 5th, 2024 to be eligible for the written test.<br/>
		<a href="https://forms.gle/efyM69xcTHZYQJh39"><button>Submit your application</button></a></font></strong></p><br/>
<p> Click the thumbnail below to download the application flyer.</p>
	<a href="https://s3.us-east-2.amazonaws.com/fireapparatusrepair.com/FH_application_flyer.png" target="new"><img width="200"src="https://s3.us-east-2.amazonaws.com/fireapparatusrepair.com/FH_application_flyer.png"/></a><br/>
   

    */}
                 <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/MEMO+-+Official+Statement+-+Martucci.pdf"><button>Official Statement Regarding Recent Criminal Charges Involving a Former Member </button></a></font><br/><br/>

             <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/Notice+of+10.21.26+Special+Meeting.docx"><button>Notice of 10.21.26 Special Meeting</button></a></font><br/><br/>

         <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/2026.10.14+Notice+of+Meeting+Cancellation.docx"><button>2026.10.14 Notice of Meeting Cancellation</button></a></font><br/><br/>
         <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/20260717133710045.pdf"><button>Re-scheduled Regular Meeting</button></a></font><br/><br/>
         <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/20260717134014010.pdf"><button>Change of Regular Meeting Start Time</button></a></font><br/><br/>



         <font size="+1"><a href="https://us06web.zoom.us/j/6087173324?pwd=UgmyEZvj2caooSBAQyxkXuSyObbty5.1&omn=86957298954"><button>Commissioners Meeting Zoom Link</button></a></font><br/><br/>
     {/*<font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/Notice+of+Special+Meeting+Re+Budget+Hearing.docx"><button>Notice of Special Meeting Re Budget Hearing</button></a></font><br/><br/>

    <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/Notice+of+Election+-+Monroe+FD1+-+Revised+by+Client.pdf"><button>Notice of Election</button></a></font><br/><br/>
 
    <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/Notice+of+Election+%26+Petitions+-+Monroe+FD1.pdf"><button>Notice of Election & Petitions</button></a></font><br/><br/>
       */}
    <Link to="/posterContestWinner">
     <button type="button">Winners of the 2026 Fire Prevention Poster Contest
     </button>
 </Link>
 <br></br>
 <br></br>
 <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/FD%231+2026+Fire+Election+Results.docx"><button>2026 Fire District Election Results</button></a></font><br/><br/>

	<p><font size="+1"><a href="https://youtu.be/f6yCtToEScQ"><button> Special Video Message From Our Fire Company</button></a></font> 
</p><br/>

<Link to="/elections">
     <button type="button">Previous Fire District Election Results
     </button>
 </Link>
    <br/><br/>
<img src="https://s3.us-east-2.amazonaws.com/fireapparatusrepair.com/newfirehouse.jpg" width="640" height="456" alt=""/>
</center>

                </div>
            </section>
        </>
    )
}
 